module.exports = __webpack_public_path__ + "img/4.735ed058.png";